<script setup lang="ts">

import LanguageIcon from "@/components/icons/navBarIcons/LanguageIcon.vue";
import Translator from "@/utils/common/Translator";
import LinkUtils from "@/utils/common/LinkUtils";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import {storeToRefs} from "pinia";

const {isSideBarOpen} = storeToRefs(useNamaFlagsStore());

const props = defineProps({
  isNotAuth: {
    type: Boolean,
    default: false
  }
})

function changeLocale() {
  let search = window.location.search;
  let queryParams = LinkUtils.getQueryParams(search);
  queryParams["locale"] = Translator.isArabic() ? "en" : "ar";
  let newSearch = "";
  for (let p in queryParams) {
    if (newSearch)
      newSearch += "&";
    newSearch = p + "=" + queryParams[p];
  }
  window.location.search = "?" + newSearch;
}
</script>

<template>
  <div id="language-button" :title="Translator.translateId('changeLocale')"
       class="tw-flex tw-justify-between tw-items-center tw-cursor-pointer  tw-relative tw-transform tw-transition-all tw-duration-1000 tw-ease-in-out"
       @click.stop="changeLocale">
    <LanguageIcon class="tw-size-5 compact:tw-size-[18px] ultra:tw-size-4"/>
    <span class="tw-px-1 ultra:tw-px-0.5 tw-text-namaFontColor-header-light dark:tw-text-namaFontColor-header-dark ultra:tw-text-xs"
          :class="[{'laptop:tw-hidden': isSideBarOpen && !isNotAuth} ,{'tablet:tw-hidden':!isNotAuth}]"
          v-text="Translator.translateId('changeLocale')"/>
  </div>
</template>

<style scoped>

</style>
